module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner-origami",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "spinner-inner loading",
    style: (_vm.innerStyles)
  }, [_c('span', {
    staticClass: "slice"
  }), _vm._v(" "), _c('span', {
    staticClass: "slice"
  }), _vm._v(" "), _c('span', {
    staticClass: "slice"
  }), _vm._v(" "), _c('span', {
    staticClass: "slice"
  }), _vm._v(" "), _c('span', {
    staticClass: "slice"
  }), _vm._v(" "), _c('span', {
    staticClass: "slice"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19389de6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-loading-spinner/src/components/Origami.vue
// module id = 899
// module chunks = 170